import { getQueryParam } from "repoV2/utils/urls&routing/urlParams";
import { URL_SEARCH_PARAMS } from "../../URLsNRouting/URLsNRouting.constants";

export const checkIsNeedToPrefillFormData = () => {
    return Boolean(getQueryParam(URL_SEARCH_PARAMS.PREFILL_FORM_DATA));
};
